<ol class="breadcrumb" >
  <li *ngFor="let org of parentOrganizationTree" class="breadcrumb-item">
    <a href="#" class="breadbrumb-item-link">{{org.organizationName}}</a>
  </li>
</ol>
